import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import portalApp from "./store/reducers/index";

const store = createStore(portalApp, applyMiddleware(thunk));

export default store